import iconChat from "../../../../assets/icon_chat.svg";
import useReactGASend from "../../../../hooks/useReactGASend";

const MessageButton = ({ label, onClick }) => {
  const { makeEventTrackFn } = useReactGASend();

  const handleClick = () => {
    makeEventTrackFn({
      category: "event",
      action: `${"채팅 상담"}(FAQ)`,
      data_btn_nm: `${"채팅 상담"}(FAQ)`,
      data_btn_url: "/chat?agree=true",
    });
  };

  return (
    <button
      className="flex items-center justify-center gap-6 p-2 font-medium bg-white border-2 min-h-12 w-60 text-neutral-900 border-neutral-600 rounded-2xl"
      onClick={() => {
        onClick();
        handleClick();
      }}
    >
      <img src={iconChat} alt="" />
      {label}
    </button>
  );
};

export default MessageButton;
